;
define("manufacturer_links.tpl", function(){});

